import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableUpsellByCheckout',
  initialState: true,
  reducers: {
    setEnableUpsellByCheckout(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableUpsellByCheckout } = slice.actions;
export default slice.reducer;
